import store from 'store'

const MONK_AUTO_ADDED_GIFTS_KEY = 'mr_cvb_fg_auto_added_quantities'
const MONK_OFFER_HEADER_SELECTOR = '.mr-embedded-widget__offer-header-con'
const MONK_OPTED_OUT_CLASS = 'monk-gift-opted-out'
const MONK_SUCCESS_MESSAGE = 'received a complimentary gift'
const CART_CONTAINER_SELECTOR = '[data-module="header-cart"], [data-module="cart-page"]'

const hasMonkGift = () => (store.state.global.cart.items || [])
  .some(item => item.properties && String(item.properties._mr) === '1')

const hasOptedOutMonkGift = () => {
  try {
    const giftGroups = JSON.parse(window.sessionStorage.getItem(MONK_AUTO_ADDED_GIFTS_KEY) || '{}')

    return Object.values(giftGroups)
      .some(group => Object.values(group || {}).some(quantity => Number(quantity) > 0))
  } catch (e) {
    return false
  }
}

const hasMonkSuccessMessage = () => [...document.querySelectorAll(MONK_OFFER_HEADER_SELECTOR)]
  .some(header => header.textContent
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .includes(MONK_SUCCESS_MESSAGE))

const syncMonkGiftBanner = () => {
  const shouldHide = !hasMonkGift() && (hasOptedOutMonkGift() || hasMonkSuccessMessage())

  for (const container of document.querySelectorAll(CART_CONTAINER_SELECTOR)) {
    container.classList.toggle(MONK_OPTED_OUT_CLASS, shouldHide)
  }

  for (const header of document.querySelectorAll(MONK_OFFER_HEADER_SELECTOR)) {
    header.hidden = shouldHide
  }
}

const hasMonkHeaderMutation = mutations => mutations.some(mutation => {
  const target = mutation.target.nodeType === window.Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement
  const changedNodes = [...mutation.addedNodes, ...mutation.removedNodes]

  return (target && target.closest(MONK_OFFER_HEADER_SELECTOR)) ||
    changedNodes.some(node => node.nodeType === window.Node.ELEMENT_NODE &&
      (node.matches(MONK_OFFER_HEADER_SELECTOR) || node.querySelector(MONK_OFFER_HEADER_SELECTOR)))
})

document.addEventListener('cart:refresh', () => {
  store.dispatch('cart/getCart').then(syncMonkGiftBanner)
})

store.watch(state => state.global.cart.items, syncMonkGiftBanner)

const observer = new window.MutationObserver(mutations => {
  if (hasMonkHeaderMutation(mutations)) {
    syncMonkGiftBanner()
  }
})

observer.observe(document.documentElement, { childList: true, subtree: true })
syncMonkGiftBanner()
